import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { useAuth } from "../stores/auth";

const API_URL = import.meta.env.VITE_API_URL || "https://inv-api.tcgeurope.it";

export const api = axios.create({ baseURL: API_URL, timeout: 30_000 });

let refreshPromise: Promise<string> | null = null;

api.interceptors.request.use((config) => {
  const tok = useAuth.getState().access;
  if (tok) config.headers.set("Authorization", `Bearer ${tok}`);
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as AxiosRequestConfig & { _retry?: boolean };
    if (error.response?.status === 401 && !original._retry && useAuth.getState().refresh) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = (async () => {
            const r = await axios.post(`${API_URL}/api/auth/refresh`, {
              refresh: useAuth.getState().refresh,
            });
            const access = r.data.access as string;
            useAuth.setState({ access });
            return access;
          })().finally(() => {
            refreshPromise = null;
          });
        }
        const access = await refreshPromise;
        original.headers = { ...(original.headers || {}), Authorization: `Bearer ${access}` };
        return axios.request(original);
      } catch {
        useAuth.getState().logout();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export type ApiError = { detail?: string };
export function errMsg(e: unknown): string {
  const ax = e as AxiosError<ApiError>;
  return ax.response?.data?.detail || ax.message || "Errore sconosciuto";
}
